/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { Autocomplete, Box, TextField } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import DriverService from "../../services/driverService";

const cacheRtl = createCache({ key: 'muirtl', stylisPlugins: [rtlPlugin] });
const cacheLtr = createCache({ key: 'ltr' });

const DriverDropdown = ({ helperText, error, setFormValues,
    isFilter, selectedDriver, setSelectedDriver, withPrices,
    cityId }) => {
    const theme = useTheme();
    const { t, i18n } = useTranslation();

    const [drivers, setDrivers] = useState([]);

    const filteredDrivers = useMemo(() => {
        if (!cityId) return drivers;
        return drivers.filter(driver => driver.cityId === cityId);
    }, [drivers, cityId]);

    useEffect(() => {
        const fetchDrivers = async () => {
            try {
                const data = withPrices ?
                    await DriverService.fetchAllWithStreets()
                    : await DriverService.fetchAll();

                const drivers = withPrices ? data : data.drivers;

                setDrivers(drivers);
            } catch (error) {
                console.error('Error fetching pages:', error);
            }
        };
        fetchDrivers();
    }, []);

    return (
        <CacheProvider value={i18n.language === 'en' ? cacheLtr : cacheRtl}>
            <Autocomplete
                options={filteredDrivers}
                getOptionLabel={(option) => {
                    if (typeof option === 'string') {
                        return option;
                    }
                    return `${option.name || ''} ${option.phone ? `(${option.phone})` : ''}`.trim();
                }}
                value={selectedDriver}
                onChange={(event, newValue) => {
                    setSelectedDriver(newValue);
                    setFormValues && setFormValues((prevValues) => ({
                        ...prevValues,
                        driverId: newValue ? newValue.id : null,
                    }));
                }
                }
                renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                        {option.name || ''} {option.phone ? `(${option.phone})` : ''}
                    </li>
                )}
                renderInput={(params) => (
                    <Box>
                        {
                            !isFilter && <p
                                style={{
                                    color: theme.palette.text.primary,
                                    fontSize: 13,
                                    marginTop: 24,
                                    marginBottom: 4,
                                }}
                            >
                                {t("driver")}
                            </p>
                        }

                        <TextField
                            {...params}
                            variant={isFilter ? 'standard' : 'outlined'}
                            fullWidth
                            placeholder={isFilter ? t('driver') : t('chooseDriver')}
                            error={!!error}
                            helperText={helperText}
                            InputProps={{
                                ...params.InputProps,
                                ...(isFilter ? { disableUnderline: true } : {}),
                                endAdornment: (
                                    <>
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                                style: {
                                    backgroundColor: isFilter ? 'transparent' : theme.palette.customGrey.insideInput,
                                    padding: '6px 8px',
                                },
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: theme.palette.customGrey.borderInput,
                                    },
                                    '&:hover fieldset': {
                                        borderColor: theme.palette.customGrey.borderInput,
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: theme.palette.primary.main,
                                    },
                                },
                                '& .MuiInputBase-input': {
                                    color: theme.palette.text.primary,
                                    padding: '6px 8px',
                                    '&::placeholder': {
                                        fontSize: '14px',
                                        color: theme.palette.text.secondary,
                                        opacity: 1,
                                    },
                                },
                            }}
                        />
                    </Box>
                )}
            />
        </CacheProvider>
    );
}

export default DriverDropdown;